<template>
  <div>
    <Message
      v-for="msg of messages"
      severity="warn"
      :key="msg"
      :closable="false"
      >{{ msg }}</Message
    >
    <form class="p-fluid p-shadow-3 form">
      <div class="p-field">
        <label for="mailaddress">メールアドレス</label>
        <InputText id="mailaddress" type="email" v-model="mail" />
      </div>
      <div class="p-field">
        <label for="password">パスワード</label>
        <InputText
          id="password"
          type="password"
          v-model="password"
          placeholder="6文字以上"
        />
      </div>
      <Button @click="signin" class="button" label="ログイン" />
      <router-link  :to="{ name: 'SignUp' }"
        ><div class="link p-mt-2">登録はこちら</div></router-link
      >
    </form>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Message from "primevue/message";
import firebase from "@/firebase/firebase";
import { useStore } from "vuex";

export default defineComponent({
  name: "SignIn",
  components: { InputText, Button, Message },
  data() {
    return {
      mail: "",
      password: "",
      messages: [],
    };
  },
  setup() {
    const store = useStore();
    return { store };
  },
  methods: {
    signin() {
      console.log("login");
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
      firebase
        .auth()
        .signInWithEmailAndPassword(this.mail, this.password)
        .then((userCredential) => {
          console.log(userCredential);
          this.$router.push("/");
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
});
</script>

<style scoped>
.form {
  text-align: left;
  height: 80%;
  width: 90%;
  padding:30px;
  max-width: 720px;
  margin: auto;
  margin-top: 50px;
}
.subform {
  margin: 16px;
}
.button {
  margin-top: 16px;
}
label {
  margin: 10px;
  width: 200px;
}
.link {
  width: 300px;
  text-align: center;
  margin: 0 auto;
}
</style>
